export default "__VITE_ASSET__oh5$Kiej__"